// extracted by mini-css-extract-plugin
module.exports = {"statistic-user-bet":"user-bet-stats_statistic-user-bet__5YF9V","user-group":"user-bet-stats_user-group__wHaUK","number":"user-bet-stats_number__R54x8"};